var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1529",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3H22.4725V22.501H2V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1529)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82347 12.1231C5.22547 16.4851 10.7645 20.0121 12.2365 20.8851C13.7135 20.0031 19.2925 16.4371 20.6495 12.1271C21.5405 9.34112 20.7135 5.81212 17.4275 4.75312C15.8355 4.24212 13.9785 4.55312 12.6965 5.54512C12.4285 5.75112 12.0565 5.75512 11.7865 5.55112C10.4285 4.53012 8.65447 4.23112 7.03747 4.75312C3.75647 5.81112 2.93247 9.34012 3.82347 12.1231ZM12.2375 22.5011C12.1135 22.5011 11.9905 22.4711 11.8785 22.4101C11.5655 22.2391 4.19247 18.1751 2.39547 12.5811C2.39447 12.5811 2.39447 12.5801 2.39447 12.5801C1.26647 9.05812 2.52247 4.63212 6.57747 3.32512C8.48147 2.70912 10.5565 2.98012 12.2345 4.03912C13.8605 3.01112 16.0205 2.72712 17.8865 3.32512C21.9455 4.63412 23.2055 9.05912 22.0785 12.5801C20.3395 18.1101 12.9125 22.2351 12.5975 22.4081C12.4855 22.4701 12.3615 22.5011 12.2375 22.5011Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1537 10.625C17.7667 10.625 17.4387 10.328 17.4067 9.93602C17.3407 9.11402 16.7907 8.42002 16.0077 8.16702C15.6127 8.03902 15.3967 7.61602 15.5237 7.22302C15.6527 6.82902 16.0717 6.61502 16.4677 6.73902C17.8307 7.18002 18.7857 8.38702 18.9027 9.81402C18.9357 10.227 18.6287 10.589 18.2157 10.622C18.1947 10.624 18.1747 10.625 18.1537 10.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.6aedc9c2c473c14e40f6f53e89964b31.svg";
export { ForwardRef as ReactComponent };